import React, { Component } from "react";
import "../Panel.css";

class Panel extends Component {
  state = {};
  constructor(props) {
    super(props);
    let d = new Date().getDate();
    let dt = new Date().getMonth();
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    let nextom = new Date(tomorrow);
    nextom.setDate(nextom.getDate() + 1);
    //let newdate = new Date(tomorrow);
    //  let newtomm = newdate.setDate(newdate.getDate() + 1);
    //console.log(newtomm);
    console.log(nextom.getDate());
    let arr = [
      d + "Today",
      tomorrow.getDate() + months[dt],
      nextom.getDate() + months[dt],
    ];
    console.log(arr);
    this.state = { arr, ind: this.props.ind };
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this.setState({ ind: this.props.ind });
    }
  }
  handleChange = (e) => {
    let { currentTarget: input } = e;
    let { price, show } = this.props;
    if (input.id === "price") {
      let cb = price.find((vl) => vl.name === input.name);
      if (cb) cb.value = input.checked;
    }
    if (input.id === "show") {
      let sh = show.find((vl) => vl.name === input.name);
      if (sh) sh.value = input.checked;
    }
    this.props.onFilter(price, show);
  };
  handleIndex = (ind) => {
    let { arr } = this.state;
    this.props.onPress(ind, arr);
  };
  render() {
    let { price, show } = this.props;
    return (
      <div className="row bg-light">
        <div className="col-5 m-1">
          <div className="row m-2">
            {this.state.arr
              ? this.state.arr.map((vl, index) =>
                  index === this.state.ind ? (
                    <button
                      className="btn m-2 btn-sm font-weight-bold"
                      style={{ backgroundColor: "#00FA9A" }}
                      onClick={() => this.handleIndex(index)}
                    >
                      {vl}
                    </button>
                  ) : (
                    <button
                      className="btn btn-light m-2 btn-sm font-weight-bold"
                      onClick={() => this.handleIndex(index)}
                    >
                      {vl}
                    </button>
                  )
                )
              : ""}
          </div>
        </div>
        <div className="col-2">
          <div className="dropdown">
            <div className="dropbtn">
              Filter price
              <i
                className="fa fa-chevron-down"
                style={{ fontSize: "14px", color: "lightgray" }}
                id="onhover"
              ></i>
              <div className="dropdown-content">
                <form className="row col-11 ml-1">
                  {price.map((vl) => (
                    <div className="form-check">
                      <input
                        type="checkbox"
                        name={vl.name}
                        value={vl.value}
                        checked={vl.value}
                        onChange={this.handleChange}
                        className="form-check-input"
                        id="price"
                      ></input>
                      <label htmlFor={vl.name} className="form-check-label">
                        {vl.name}
                      </label>
                    </div>
                  ))}
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="col-2">
          <div className="dropdown">
            <div className="dropbtn">
              Filter Showtime
              <i
                className="fa fa-chevron-down"
                style={{ fontSize: "14px", color: "lightgray" }}
                id="onhover"
              ></i>
              <div className="dropdown-content">
                <form className="row col-11 ml-1">
                  {show.map((vl) => (
                    <div className="form-check">
                      <input
                        type="checkbox"
                        name={vl.name}
                        value={vl.value}
                        checked={vl.value}
                        onChange={this.handleChange}
                        className="form-check-input"
                        id="show"
                      ></input>
                      <label htmlFor={vl.name} className="form-check-label">
                        {vl.name}
                      </label>
                    </div>
                  ))}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Panel;
